import { useMutation } from '@tanstack/react-query';
import { FIVE_SECONDS, TEN_SECONDS, TOAST_ERROR, TOAST_SUCCESS, showToast } from 'lib/utils';

import { makeLinkRollfiUser } from 'main/factories/usecases/rollfi';
import { useParams } from 'react-router-dom';

export const useLinkRollfiUser = () => {
  const { locationId: currentLocationId } = useParams();

  return useMutation({
    mutationFn: (userId: string) => {
      const service = makeLinkRollfiUser();
      return service.linkRollfiUser({ locationId: String(currentLocationId), userId });
    },
    onError: () => {
      showToast('Error while linking Rollfi user', TOAST_ERROR, TEN_SECONDS);
    },
    onSuccess: () => {
      showToast('Rollfi user linked successfully', TOAST_SUCCESS, FIVE_SECONDS);
    },
  });
};
